import React, { useState, useEffect } from "react";
import { Grid, Icon, List, Label } from "semantic-ui-react";
import moment from "moment";
moment.locale("fr");

const styles = {
	mainContainer: {
		backgroundColor: "rgb(1, 84, 111)",
		color: "#fff",
		borderRadius: "4px",
		border: "1px solid rgb(1, 84, 111)",
		boxShadow: "0px 9px 20px -23px rgba(148,148,148,1)",
		width: "100%",
		display: "flex",
		alignItems: "center",
		maxHeight: "62px",
		overflowX: "auto",
		overflowY: "auto",
	},
	row: {
		paddingTop: 3,
		paddingBottom: 3,
	},
};
const SidebarTvSec = ({ comments }) => {
	const [manualCommentsSorted, setManualCommentsSorted] = useState([]);

	useEffect(() => {
		setManualCommentsSorted(
			comments && comments.length > 0 ? comments.filter((c) => c.manual).sort((a, b) => moment(b.created_at).diff(moment(a.created_at))) : []
		);
	}, [comments]);

	const displayComment = (c) => (
		<div key={`comment-${c.id}`} style={{ margin: 0, display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
			<div>
				<span style={{ fontSize: "0.8em" }}>
					{moment(c.created_at).format("DD MMM") !== moment().format("DD MMM") ? moment(c.created_at).format("DD MMM").concat(" à ") : ""}
					{moment(c.created_at).format("HH:mm")} :
				</span>{" "}
				{c.cancellation && c.cancelReason ? `Annulation de la demande : ${c.cancelReason.label}` : ""}
				{c.comment ? <i>{` ${c.comment}`}</i> : ""}{" "}
				<Label size="tiny" style={{ marginLeft: "8px" }}>
					{c.created_by?.first_name} {c.created_by?.last_name}
				</Label>
			</div>
		</div>
	);
	return (
		<>
			<Grid style={styles.mainContainer}>
				<Grid.Row style={styles.row}>
					<Grid.Column computer={1}>
						<Label attached="top left" color="orange" style={{ display: "flex" }}>
							<Icon name="comments outline" />
							{manualCommentsSorted.length}
						</Label>
					</Grid.Column>
					<Grid.Column mobile={15} computer={15} style={{ maxHeight: "60px", overflowY: "auto", minHeight: "30px" }}>
						{manualCommentsSorted.length > 1 && (
							<div style={{ display: "flex", flexDirection: "column" }}>
								<List divided relaxed>
									{manualCommentsSorted.map((c, index) => (
										<List.Item key={`comment${index}`} style={{ margin: 0, padding: "0 5px" }}>
											<List.Icon name="angle right" size="tiny" verticalAlign="middle" />
											<List.Content>{displayComment(c)}</List.Content>
										</List.Item>
									))}
								</List>
							</div>
						)}

						{manualCommentsSorted.length === 1 && (
							<List divided relaxed>
								{manualCommentsSorted.map((c) => (
									<List.Item style={{ margin: 0, padding: 0 }}>
										<List.Icon name="angle right" size="tiny" verticalAlign="middle" />
										<List.Content>{displayComment(c)}</List.Content>
									</List.Item>
								))}
							</List>
						)}
					</Grid.Column>
				</Grid.Row>
			</Grid>
		</>
	);
};
export default SidebarTvSec;
